<template>
  <div class="w-source">
    <router-view/>
<!--    <wheelLandIntercept></wheelLandIntercept>-->
  </div>
</template>

<script>
  // import wheelLandIntercept from './components/wheelLandIntercept'

  export default {
    name: 'App',
    // components: {wheelLandIntercept},
    mounted() {
        // console.log(this.$route)
      // console.log(this.$route.params)
      // this.$router.push({path: `/info/${25}`,})
      // this.$router.push({ name: 'taskInfo',params:{projectId:59286,taskId:34}})
    }
  }

//ios禁止缩放
//   window.onload = function() {
//     document.addEventListener('touchstart', function(event) {
//       if (event.touches.length > 1) {
//         event.preventDefault()
//       }
//     })
//     document.addEventListener('gesturestart', function(event) {
//       event.preventDefault()
//     })
//   }
</script>



// WEBPACK FOOTER //
// src/App.vue